export const isEmailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isPhoneNumberRegex = /^(\+49)[0-9]{6,20}$/;

export const isCustomerPasswordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
export const isGuaranteeAgentPasswordRegex =
  /^(?=.*\d)(?=.*[a-z])(?=.*[\W_])(?=.*[A-Z])[^\s]{12,}$/;
export const isBankAdvisorPasswordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[\W_])(?=.*[A-Z])[^\s]{12,}$/;
export const isLeasingAdvisorPasswordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

export const isDateFormattedRegex = /^\s*(\d{1,2})\.(\d{1,2})\.(\d{4})\s*$/;
